export default __webpack_public_path__ + "static/media/26_4_2.d5f9ffe0.png";